<template>
    <section class="relative">
        <div class="mt-5 text-gray-400">
            <p>{{display}}</p>
        </div>
        <div class="w-1/3 md:w-full" style="overflow:auto; height:20rem">
            <div @click="openChat(message)" v-for="message in messages" :key="message" class="cursor-pointer bg-gray-200 p-4 text-sm  md:w-full mt-8 rounded-xl">
                <div  >
                    <div  class="flex">
                        <div>
                            <img src="../assets/customer-pic1.png" alt="pic">
                        </div>

                        <div class="ml-4 ">
                            <div class="flex justify-between">
                                <p class="text-blue-600">{{message.customerName}}</p>
                                <p>{{moment(message.lastMessagePostedAt).format('hh:mma')}}</p>
                            </div>
                            <p class="inline-block whitespace-nowrap overflow-hidden overflow-ellipsis w-60">
                                {{message.lastMessage}}
                            </p>
                        </div>
                
                    </div>
                </div>
            </div>
        </div>

        <div v-if="isOpenChat" class=" w-1/2 md:w-full md:mr-0 mt-10 bg-gray-100 absolute lg:relative top-0 right-0 rounded-2xl mr-10">
            <div>
                <div style="width:100%" class=" flex justify-between pt-4 rounded-2xl bg-gray-200">
                    <div class="ml-3">
                        <p class="text-blue-600">{{customerName}}</p>
                        <p>Online</p>
                    </div>
                    <div class="mr-3 pb-2">
                        <i class="fa fa-phone text-white bg-green-400 p-3 rounded-full"></i>
                        <p class="text-blue-600 text-sm">Contact</p>
                    </div>
                </div>
                
                <div class="p-4 pt-20 " style="overflow:auto; height:20rem">
                    <div v-for="userMessage in chats.reverse()" :key="userMessage">
                        <div v-if="userMessage.chatId == userMessage.senderId" class=" w-4/5 float-left ">
                            <div class="flex mt-4">
                                <img class="w-10 h-10" src="../assets/customer-pic1.png" alt="pic">
                                <p class="ml-4 bg-blue-500 text-white p-4 rounded-2xl">
                                    {{userMessage.message}}
                                </p>
                            </div>
                            
                        </div>
                        
                        <div v-if="userMessage.chatId !== userMessage.senderId" class="border w-4/5 float-right bg-blue-300 rounded-2xl text-white p-4 mt-6">
                            <p>{{userMessage.message}}</p>
                        </div>
                    </div>

                </div>
            </div>
            
            <form @submit.prevent="sendMessage">
                <div class="pb-10">
                    <textarea rows="1" cols="1" class="w-full mt-10 p-2 rounded-2xl border outline-none border-blue-600 relative" v-model="chatMessage"></textarea>
                    <button ><i class="fa fa-paper-plane absolute bottom-14 right-4"></i></button>
                </div>
            </form>
        </div>
        
    </section>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    data() {
        return {
            chatMessage: "",
            messages : [],
            chats : [],
            customer: "",
            admin: "",
            sender: String,
            customerName: String,
            isOpenChat: false,
            theMessage : "",
            sendAdminMessage : [
                
            ],
            userId: localStorage.getItem('userId'),
            postMessage : "",
            display: "",
            time : null
            
        }
    },

    mounted() {
        this.getMessages();
        this.created();
        this.networkError();

    },

    

    methods: {
        moment(date) {
            return moment(date)
        }, 

        created() {
            console.log("Starting connection to WebSocket Server")
            let connection = new WebSocket(`ws://carrygo.me/`)

            connection.onmessage = function(event) {
                console.log(event);
                this.time = event.data;
            }

            connection.onpen = function(event) {
                console.log(event)
                console.log("Successfully connected to the echo websocket server...")
        }},

        getMessages() {
           
            axios({
                method: 'GET',
                url: `${url}/v1/web/chats/${this.userId}?sortBy=name&limit=20&page=1&order=desc`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer ' + localStorage.getItem("token"),
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {

                this.messages = response.data.data.results
                this.admin = this.messages.customerId;
                if(this.messages.length <= 0) {
                    this.display = "You don't have any messages"
                }
            })
            .catch((error) => {
                console.log(error)
            })
        },

        openChat(message) {
             this.getChat(message.chatId);
             this.isOpenChat = true;
             this.admin = message.adminId
             this.customer = message.customerId
             this.customerName = message.customerName
            
        },

        sendMessage() {
            // this.connection.send(this.chatMessage);
        //    let adminId = localStorage.getItem("userId");

            axios({
                method: 'POST',
                url: `${url}/v1/web/chats/message/send`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer ' + localStorage.getItem("token"),
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data: {
                    "adminId" : this.admin,
                "customerId": this.customer,
                "senderId": this.userId,
                "message": this.chatMessage
                }
            })
            .then((res) => {
                res.json;
                this.chats.push(this.chatMessage)
                this.chatMessage = "";
                this.getMessages();
            })
            .catch((error) => {
                console.log(error)
            })
        },

        getChat(id) {
            axios({
                method: 'GET',
                url: `${url}/v1/web/chats/messages/${id}?sortBy=name&limit=20&page=1&order=desc`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer ' + localStorage.getItem("token"),
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                this.chats = []
                this.chats = response.data.data.results
            })
            .catch((error) => {
                console.log(error)
            })
        },

        networkError() {
            if(!navigator.onLine) {
                this.$router.push('/network-error')
            } 
        }
    }
}
</script>

